// Source/Bonus-Popup/Component.ts
class BonusPopup extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    const onClose = this.onClose.bind(this);
    this.closer.addEventListener("click", onClose, {
      signal
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  onClose(event) {
    event.stopImmediatePropagation();
    event.preventDefault();
    console.debug("Closing");
    this.dialog.close();
  }
  get dialog() {
    return this.querySelector(`.Bonus-Popup-Dialog`);
  }
  get closer() {
    return this.querySelector(`.Bonus-Popup-Close`);
  }
}

// Source/Bonus-Popup/mod.ts
customElements.define("bonus-popup", BonusPopup);
